import { put, takeLatest, call, delay, select } from 'redux-saga/effects'
import { message } from 'antd'
import { AxiosResponse } from 'axios'

import { DEFAULT_THROTTLE_MS } from 'globalConstants'
import { API, api } from 'services/api'

import * as actionTypes from './adminManagement.actionTypes'
import {
  addAdminRequest,
  addAdminError,
  addAdminSuccess,
  resetAdminFormAction,
  fetchAdminsSuccess,
  fetchAdminsFailure,
  toggleAdminSuspendSuccess,
  toggleAdminSuspendFailure
} from './adminManagement.actions'
import { IAdmin, IAdminManagementState } from './adminManagement.types'

function* addAdminSaga({ payload }: ReturnType<typeof addAdminRequest>) {
  try {
    yield call(api.post, API.ADD_ADMIN, payload)

    yield put(addAdminSuccess())
    yield put(resetAdminFormAction({ resetForm: true }))
    yield call(message.success, 'Admin added!')

    yield delay(DEFAULT_THROTTLE_MS)
    yield put(resetAdminFormAction({ resetForm: false }))
  } catch (e: any) {
    yield put(addAdminError(e))
  }
}

function* fetchAdminsSaga() {
  try {
    const response: AxiosResponse<IAdmin[]> = yield call(api.get, '/management/admins')
    yield put(fetchAdminsSuccess(response.data))
  } catch (error) {
    yield put(fetchAdminsFailure(error.message))
  }
}

function* toggleAdminSuspendSaga(action: { type: string; payload: string }) {
  try {
    const response: AxiosResponse<{ suspended: boolean }> = yield call(
      api.patch,
      `/management/admin/${action.payload}/suspend`
    )

    const state: { adminManagement: IAdminManagementState } = yield select()
    const adminToUpdate = state.adminManagement.admins.find(
      (admin: IAdmin) => admin.id === action.payload
    )

    if (adminToUpdate) {
      yield put(
        toggleAdminSuspendSuccess({
          ...adminToUpdate,
          suspended: response.data.suspended
        })
      )

      yield call(
        message.success,
        `Admin status ${response.data.suspended ? 'suspended' : 'activated'}`
      )
    }
  } catch (error) {
    yield put(toggleAdminSuspendFailure(error.message))
  }
}

export function* adminManagementSaga() {
  yield takeLatest(actionTypes.ADD_ADMIN_REQUEST, addAdminSaga)
  yield takeLatest(actionTypes.FETCH_ADMINS_REQUEST, fetchAdminsSaga)
  yield takeLatest(actionTypes.TOGGLE_ADMIN_SUSPEND_REQUEST, toggleAdminSuspendSaga)
}

export function* watchAdminManagement() {
  yield takeLatest(actionTypes.FETCH_ADMINS_REQUEST, fetchAdminsSaga)
  yield takeLatest(actionTypes.TOGGLE_ADMIN_SUSPEND_REQUEST, toggleAdminSuspendSaga)
}
